'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MethodDescriptor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _callClassFactory = require('./callClassFactory');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MethodDescriptor = exports.MethodDescriptor = function () {
    function MethodDescriptor(serviceDescriptor, methodName, methodType, _ref, serviceMethod) {
        var request = _ref.request,
            response = _ref.response;

        _classCallCheck(this, MethodDescriptor);

        this.serviceDescriptor = _auroraJavascriptUtils.assert.object(serviceDescriptor);
        this.methodType = methodType;
        this.methodName = _auroraJavascriptUtils.assert.string(methodName);
        this.requestModel = request;
        this.responseModel = response;
        this.Call = (0, _callClassFactory.createCallClass)(this, request, response);
        this.serviceMethod = serviceMethod;
        this.callIdIndex = 0;
    }

    _createClass(MethodDescriptor, [{
        key: 'createCall',
        value: function createCall(rawRequest, serviceInstance) {
            var _this = this;

            var call = new this.Call({
                request: rawRequest,
                id: ++this.callIdIndex,
                executor: function executor(request) {
                    return _this.serviceMethod.call(serviceInstance, request);
                }
            });

            return call;
        }
    }]);

    return MethodDescriptor;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/MethodDescriptor.js
// module id = 1420
// module chunks = 118